import {Routes} from '@angular/router';
import {MainMenuComponent} from './main-menu/main-menu.component';
import {NewHealthRequestComponent} from './new-health-request/new-health-request.component';
import {BasicInformationComponent} from './basic-information/basic-information.component';
import {NewSubRequestComponent} from './new-sub-request/new-sub-request.component';
import {OfferSelectComponent} from './offer-select/offer-select.component';
import {SubRequestDetailsComponent} from './sub-request-details/sub-request-details.component';
import {QuestionsComponent} from './questions/questions.component';
import {NotFoundComponent} from '../not-found/not-found.component';
import {RoleGuard} from '../../services/guards/role-guard.service';

export const healthRoutes = [
  {
    path: 'health/family',
    children: [
      {
        path: 'details',
        component: SubRequestDetailsComponent,
        canActivate: [RoleGuard],
        data: {role: 'user'}
      },
      {
        path: '',
        component: MainMenuComponent
      },
      {
        path: 'new-request',
        component: NewHealthRequestComponent,
      },
      {
        path: 'basic-information',
        component: BasicInformationComponent
      },
      {
        path: 'new-sub-request',
        component: NewSubRequestComponent
      },
      {
        path: 'health-offer',
        component: OfferSelectComponent
      },
      {
        path: 'forms',
        component: QuestionsComponent,
        canActivate: [RoleGuard],
        data: {role: 'user'}
      },
      {
        path: '**',
        component: NotFoundComponent
      }
    ]
  }
];
